
<template>
  <!-- 专业名称 -->
  <div>
    <el-dialog title="专业名称" :visible.sync="dialogTableVisible" append-to-body>
      <div class="query-form">
        <el-form
          ref="form"
          :model="form"
          label-position="right"
          label-width="80px"
        >
          <el-row :gutter="24">
            <el-col :span="8" >
              <el-form-item
                label="专业名称"
                prop="zymc"
              >
                <el-input
                  v-model="form.zymc"
                  placeholder="请输入"
                ></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row
            style="display: flex; justify-content: flex-end; align-items: center"
          >
            <el-col :span="2" :offset="18">
              <el-button type="primary" size="small" @click="getInfo">查询</el-button>
            </el-col>
            <el-col :span="2">
              <el-button type="info" size="small" @click="clear">重置</el-button>
            </el-col>
          </el-row>
        </el-form>
      </div>
      <el-table height="350" border :data="gridData" 
        @sort-change="handleSortChange"
        :header-cell-class-name="handleHeadAddClass"
      >
        <el-table-column
          property="zydm"
          label="专业代码"
        ></el-table-column>
        <el-table-column
          property="zymc"
          label="专业名称"
          sortable="custom"
        ></el-table-column>
        <el-table-column
          property="zylbmc"
          label="专业类别"
        ></el-table-column>
        <el-table-column label="操作" width="100">
          <template slot-scope="scope">
            <el-button size="mini" @click="choice(scope.row)">选择</el-button>
          </template>
        </el-table-column>
      </el-table>
      <div>
        <pagination :total="pagination.total" 
          @currentPageChange="currentPageChange" 
          @pageSizeChange="pageSizeChange"
          :pageSizes="pageSizes">
        </pagination>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import share from "@/assets/sharejs/share.js";
import request from "@/api/postList.js";
import pagination from "@/components/pagination.vue";

let cols = [];
export default {
  props: ['zplb'],
  components: {
    pagination
  },
  data() {
    return {
      gridData: [],
      sortField: {},
      orderBys: [], //存储排序信息
      dialogTableVisible: false,
      form: {
        zymc: "",
      },
      keyword: "",
      zylb: "",
      pagination: {
        total: 0,
        pageSize: 10,
        page: 1,
      },
      pageSizes: [10, 30, 50, 100],
      queryType: ""
    };
  },
  watch: {
    dialogTableVisible() {
      if(this.dialogTableVisible){
        this.getInfo()
      }
    },
  },
  methods: {
    open(data) {
      this.queryType = data.queryType;
      this.form.zymc = data.keyword;
      this.zylb = data.zylb;
      this.dialogTableVisible = true;
    },
    close() {
      this.dialogTableVisible = false;
    },
    //排序方法
    async handleSortChange({ order, prop }) {
      this.orderPage = order;
      this.propPage = prop;
      // 触发的排序和缓存的排序相同时，取消该字段的排序
      if (!order || this.sortField[prop] === order) {
          this.sortField[prop] = null;
      } else {
          this.sortField[prop] = order;
      }
      console.log("对象存储数据>>>>>", this.sortField);

      this.orderBys = [];

      let direction = "";
      for (var i in this.sortField) {
          if (this.sortField[i] == "ascending") {
              direction = "ASC";
          } else if (this.sortField[i] == "descending") {
              direction = "DESC";
          } else {
              direction = "";
          }

          this.orderBys.push({
              column: i,
              direction: direction,
          });
      }

      this.getInfo();
    },

    handleHeadAddClass({ column }) {
        cols.push(column); //重置使用数组
        if (this.sortField[column.property]) {
            column.order = this.sortField[column.property];
        }
    },
    clear(){
      this.form.zymc = "";

      this.pagination.page = 1;
      this.pagination.pageSize = 10;
      this.pagination.total = 0;
      this.gridData = [];
      this.sortField = {};
      this.orderBys = [];
      cols.forEach((col) => {
          col.order = "";
      });
    },
    pageSizeChange(e) {
      this.pagination.pageSize = e;
      this.pagination.page = 1;
      this.getInfo();
    },
    currentPageChange(e) {
      this.pagination.page = e;
      this.getInfo();
    },
    /* 获取信息 */
    async getInfo() {
      var orderInfo = JSON.stringify(this.orderBys);
      const para = {
        zymc: this.form.zymc,
        zylb: this.zylb,
        zplb: this.zplb,
        page: this.pagination.page, //页码
        pageSize: this.pagination.pageSize, //每页显示的条数
        orderInfo: orderInfo,
      };
      const data = await request.queryMajor(para);
      this.gridData = data.vds.map((item)=>{
        return {
            ...item,
            zylbmc: share.getValue('zylb', item.zylb),
        }

      });
      this.pagination.total = data.total;
    },
    /* 选择 */
    choice(data) {
      const params = {
        ...data,
        "queryType": this.queryType
      }
      this.$emit("choiceData", params);
      this.dialogTableVisible = false;
    },
  },
};
</script>

<style>
.query-form {
  transition: display 0.5s;
}
</style>